import localforage from "localforage";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useGetActiveMenu } from "~/queries/use-get-active-menu";
import { useGetActiveMenuCategories } from "~/queries/use-get-active-menu-categories";
import { useGetCurrentDevice } from "~/queries/use-get-current-device";
import { useGetCurrentLocation } from "~/queries/use-get-current-location";
import { useGetCurrentVenue } from "~/queries/use-get-current-venue";
import { useGetOrder } from "~/queries/use-get-order";
import { setState, useLocationId, useVenueId } from "~/store";
import { State } from "~/types/store";
import { DIGITAL_MENU_LANGUAGE } from "~/types/__generated/gql/graphql";
import { getPayloadFromToken } from "~/utils/get-payload-from-token";
import { SHARED_STORAGE_KEYS } from "~served/ui-comps/storage-keys";

export const useInitApp = () => {
	const router = useRouter();

	useGetCurrentDevice();
	useGetOrder();
	const { data: venue } = useGetCurrentVenue();
	const { data: menu } = useGetActiveMenu();
	useGetActiveMenuCategories();
	useGetCurrentLocation();

	// Synced from data rather than onSuccess: fresh data restored from the persisted cache isn't refetched.
	const venueId = useVenueId();
	const isVenueLoaded = !!venueId && venue?._id === venueId;
	useEffect(() => {
		if (isVenueLoaded) setState({ isReady: true });
	}, [isVenueLoaded]);

	const locationId = useLocationId();
	const menuId = locationId ? menu?._id : undefined;
	useEffect(() => {
		if (menuId) setState({ menuId });
	}, [menuId]);

	useEffect(() => {
		async function start() {
			const obj = {} as State;
			if (router.query.token) {
				obj.token = router.query.token as string;
				const { venueId, locationId } = getPayloadFromToken(obj.token);
				obj.venueId = venueId;
				obj.locationId = locationId;
			}
			if (router.pathname === "/thank-you" && router.query.ref)
				obj.orderRef = router.query.ref as string;
			else obj.orderRef = null;
			if (router.pathname === "/thank-you" && router.query.id)
				obj.orderId = router.query.id as string;
			else obj.orderId = null;
			const persistedLanguage = await localforage.getItem<string>(
				SHARED_STORAGE_KEYS.DIGITAL_MENU_LANGUAGE,
			);
			obj.activeDigitalMenuLanguage = "en";
			if (persistedLanguage && persistedLanguage !== "en") {
				obj.activeDigitalMenuLanguage =
					persistedLanguage as DIGITAL_MENU_LANGUAGE;
			}

			if (
				(router.pathname === "/menu" || router.pathname === "/cart") &&
				!router.query.token
			) {
				await router.replace(
					"/errors?title=OOPS! Ordering not allowed&description=Make sure you scan and follow the QR you can find at one our partners' location.",
				);
			}

			setState({ ...obj });
		}

		if (router.pathname === "/" || router.pathname === "/thank-you")
			setState({ isReady: true });
		if (router.pathname !== "/" && Object.keys(router.query).length) {
			void start();
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [router.query.token, router.query.ref, router.query.id]);
};
